import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, AbstractControl, FormGroup } from '@angular/forms';
import { Person } from '@/interfaces/person';

export interface Option {
  id: string;
  value: string;
}

@Component({
  selector: 'app-select-person',
  templateUrl: './select-person.component.html',
  styleUrls: ['./select-person.component.css'],
})
export class SelectPersonComponent {

  @Input() controlForm: FormControl | AbstractControl = new FormControl(0);

  @Input() title: string = '';
  @Input() placeHolder: string = '';
  @Input() hintText: string = '';
  @Input() optionList: Option[] = [];
  @Input() textInformation: string = '';
  @Input() optional: boolean = false;
  @Input() listPersonOptions: Option[] = [];

  @Output() textInputValueEmitter = new EventEmitter<string>();
  @Output() selectedValueEmitter = new EventEmitter<string>();

  personForm: FormGroup = new FormGroup({
    filterText: new FormControl(''),
    id: new FormControl(-1),
  });

  textInputValue = new FormControl('');
  selectedValue = new FormControl('');

  selectedPersonData?: Person;

  constructor() { }

  onTextInputChange(value: string) {
    if (value !== this.selectedValue.value) {
      this.textInputValueEmitter.emit(value);
      this.selectedValueEmitter.emit('');
    }
  }

  onSelectValue(event: MouseEvent) {
    const selectedId = (<any>event.target).id as string;
    let selectedValue = this.optionList.find(({ id }) => id == selectedId);

    if (selectedValue) {
      selectedValue = <Option>selectedValue;
      this.selectedValue.setValue(selectedValue.value);
      this.textInputValue.setValue(selectedValue.value);
      this.selectedValueEmitter.emit(selectedValue.id);
      this.optionList = [];
    }
  }

  onUnselect() {
    this.personForm.patchValue({ id: -1, filterText: '' });
    this.controlForm.patchValue(0);
    this.selectedPersonData = undefined;
    this.listPersonOptions = [];
  }
}
